module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("色彩")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("基础色 和 主题色")])]), _vm._v(" "), _c('h2', [_vm._v("基础色")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_c('color'), _vm._v(" "), _c('color', {
    attrs: {
      "type": "red"
    }
  }), _vm._v(" "), _c('color', {
    attrs: {
      "type": "green"
    }
  }), _vm._v(" "), _c('color', {
    attrs: {
      "type": "yellow"
    }
  }), _vm._v(" "), _c('color', {
    attrs: {
      "type": "neutrals"
    }
  })], 1), _vm._v(" "), _c('h2', [_vm._v("主题色")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_c('color', {
    attrs: {
      "type": "vi"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("基础色在 "), _c('code', [_vm._v("/src/style/themes/colors/ui.styl")]), _vm._v(" 文件中修改")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("主题色在 "), _c('code', [_vm._v("/src/style/themes/colors/vi.styl")]), _vm._v(" 文件中修改")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99c7bbb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/color-18.vue
// module id = 684
// module chunks = 0